var map = {
	"./Pages/AboutUs/AboutUs.module": [
		"./src/app/Pages/AboutUs/AboutUs.module.ts",
		"Pages-AboutUs-AboutUs-module"
	],
	"./Pages/Contact/Contact.module": [
		"./src/app/Pages/Contact/Contact.module.ts",
		"Pages-Contact-Contact-module"
	],
	"./Pages/Faq/Faq.module": [
		"./src/app/Pages/Faq/Faq.module.ts",
		"Pages-Faq-Faq-module"
	],
	"./Pages/Portfolio/Portfolio.module": [
		"./src/app/Pages/Portfolio/Portfolio.module.ts",
		"Pages-Portfolio-Portfolio-module"
	],
	"./Pages/Pricing/Pricing.module": [
		"./src/app/Pages/Pricing/Pricing.module.ts",
		"Pages-Pricing-Pricing-module"
	],
	"./Pages/Search/Search.module": [
		"./src/app/Pages/Search/Search.module.ts",
		"Pages-Search-Search-module"
	],
	"./Pages/Services/Services.module": [
		"./src/app/Pages/Services/Services.module.ts",
		"Pages-Services-Services-module"
	],
	"./Pages/Session/Session.module": [
		"./src/app/Pages/Session/Session.module.ts",
		"Pages-Session-Session-module"
	],
	"./Pages/Team/Team.module": [
		"./src/app/Pages/Team/Team.module.ts",
		"Pages-Team-Team-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;